import { useEffect } from "react";
import ReportUtils from "../../../../../utils/report-utils.js";

const ReportContent = ({ data, tableColumns }) => {
    useEffect(() => {
        const exportColumns = [
            {id: "dateTime", label: "D/H partida", value: (item) => item.displacement_goingdate ?? ""},
            {id: "dateTime", label: "D/H chegada", value: (item) => item.displacement_arrivaldate ?? ""},
            {id: "place", label: "Local pré-cadastrado", value: (item) => item.displacement_destiny ?? ""},
            {id: "address", label: "Endereço", value: (item) => item.displacement_number ? `${item.displacement_street}, ${item.displacement_number}` : item.displacement_street},
            {id: "neighborhood", label: "Bairro", value: (item) => item.displacement_neighborhood ?? ""},
            {id: "sector", label: "Setor", value: (item) => item.garrison_sectors ?? ""},
            {id: "team", label: "Equipe", value: (item) => item.garrison_team ?? ""},
            {id: "garrison", label: "Guarnição", value: (item) => item.garrison_name ?? ""},
        ].filter((column) => tableColumns?.[column.id]?.visible !== false);

        const columns = exportColumns.map((column) => column.label);
        const values = data.map((item) => exportColumns.map((column) => column.value(item)));

        ReportUtils.createExportableTable(columns, values, "Sequência de deslocamentos",);
    }, [data, tableColumns]);

    const columns = [
        {
            id: "dateTime",
            label: "D/H",
            render: (item) =>
                [item.displacement_goingdate, item.displacement_arrivaldate].filter(Boolean).join(" até ") || "Não informado",
            print: (item) => (
                <>
                  <span className="hidden print:table-cell">
                    {item.displacement_goingdate ?? "Não informado"}
                  </span>

                  <span className="hidden print:table-cell">
                    {item.displacement_arrivaldate ?? "Não informado"}
                  </span>
                </>
            ),
        },
        {
            id: "place",
            label: "Local pré-cadastrado",
            render: (item) => item.displacement_destiny ?? "Não informado",
        },
        {
            id: "address",
            label: "Endereço",
            render: (item) => [item.displacement_street, item.displacement_number].filter(Boolean).join(", ") || "Não informado",
        },
        {
            id: "neighborhood",
            label: "Bairro",
            render: (item) => item.displacement_neighborhood ?? "Não informado",
        },
        {
            id: "sector",
            label: "Setor",
            className: "w-[150px]",
            render: (item) => item.garrison_sectors || "Não informado",
        },
        {
            id: "team",
            label: "Equipe",
            render: (item) => item.garrison_team ?? "Não informado",
        },
        {
            id: "garrison",
            label: "Guarnição",
            render: (item) => item.garrison_name ?? "Não informado",
        },
    ];

    const visibleColumns = columns.filter(
        (column) => tableColumns?.[column.id]?.visible !== false,
    );

    return (
        <>
            {visibleColumns.length ? (
                <table id="displacement-list-data" className="table report-table" sheet-name="Sequência de deslocamentos">
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.flatMap((column) =>
                                column.id === "dateTime" ? (
                                    [
                                        <th key="dateTime" className="print:hidden">{tableColumns.dateTime.label}</th>,
                                        <th key="start" className="hidden print:table-cell">D/H partida</th>,
                                        <th key="end" className="hidden print:table-cell">D/H chegada</th>,
                                    ]
                                ) : (
                                    <th key={column.id} className={column.className}>
                                        {tableColumns[column.id].label}
                                    </th>
                                ),
                            )}
                        </tr>
                    </thead>

                    <tbody className="bg-white">
                        {data.map((item, index) => (
                            <tr key={index}>
                                {visibleColumns.flatMap((column) =>
                                    column.id === "dateTime" ? (
                                        [
                                            <td key="dateTime" className="print:hidden">{column.render(item)}
                                            </td>, <td key="start" className="hidden print:table-cell">{item.displacement_goingdate ?? "Não informado"}</td>,
                                            <td key="end" className="hidden print:table-cell">{item.displacement_arrivaldate ?? "Não informado"}</td>,
                                        ]
                                    ) : (
                                        <td key={column.id} className={column.className}>
                                            {column.render(item)}
                                        </td>
                                    ),
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
                    Todas as colunas foram ocultadas.
                </div>
            )}

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;